// project import
import CommonLayout from 'layout/CommonLayout';
import OAuthConsentPage from 'pages/oauth-consent/OAuthConsentPage';
import AuthGuard from 'utils/route-guard/AuthGuard';

// ==============================|| OAUTH CONSENT ROUTING ||============================== //

/**
 * portal-be only ever redirects a browser here once its session is authenticated, so this route
 * needs `AuthGuard`, not `LoginRoutes`'s `GuestGuard` (which would bounce a logged-in user away
 * from it). It stays out of `MainRoutes` on purpose: that table wraps every route in
 * `MainLayout`'s full app shell (sidebar, header), which a security decision interstitial should
 * not carry.
 */
const OAuthConsentRoutes = {
    path: '/',
    children: [
        {
            path: '/',
            element: (
                <AuthGuard>
                    <CommonLayout />
                </AuthGuard>
            ),
            children: [
                {
                    path: 'oauth2/consent',
                    element: <OAuthConsentPage />,
                },
            ],
        },
    ],
};

export default OAuthConsentRoutes;
